// views.app.settings.settings.company

export const COMPANY = {
  title: 'Company Profile',
  description: 'Information relating to your organization that helps configure what is relevant for you.'
};
